import { useDispatch, useSelector } from "react-redux";
import { clearUXManagement, setUXManagement } from "../redux/ux-management-slice";
import { AppState } from "../redux/store";
import { useCallback } from "react";


/**
 * Manages persisted UX state buckets keyed by property name.
 * @param propertyName - Key of the UX state collection to interact with.
 * @returns Tuple with current state, clear helper, and setter.
 */
export function useUxManagement<T>(propertyName: string) {

    const dispatch = useDispatch();
    const _state = useSelector<AppState>(state => state.uxManagement[propertyName]) as T;
    
    /**
     * Removes stored UX entries for the provided identifiers.
     * @param ids - Identifiers to clear from the UX bucket.
     */
    const clear = useCallback((ids: string[]) => {
        dispatch(clearUXManagement({ eventName: propertyName, items: ids}))
    }, [dispatch, propertyName])

    /**
     * Persists UX data for the configured property.
     * @param data - Value to store for the property name.
     */
    const set = useCallback((data: T) => {
        dispatch(setUXManagement({ eventName: propertyName, eventData: data}))
    }, [dispatch, propertyName])
    
    return [_state, clear, set] as const;
}
